import HeaderNone from './../../components/component/header/header_none.jsx';

import BlogsComponent from './../../components/component/blog_components/blog.jsx';


import FooterNone from './../../components/component/footer/footer_none.jsx'
import LaptopFooter from './../../components/component/footer/laptop_footer.jsx';



function Blogs() {
    return (
            <main>
                <HeaderNone />
                <BlogsComponent />

                <FooterNone />
                <LaptopFooter />

            </main>
    );
}

export default Blogs;

